<template>
  <el-main>
    <query-gather :is-add="authorityMap.isAdd" :is-reset="true" :is-select="true" :is-query="false"
                  :is-input="false"
                  :select-options="gzMcOptions" :cur-select-tip="curSelectLabel" :is-select-clear="true"
                  @qgAddDeal="addItemDeal" @qgDownSelectDeal="qgDownSelectDeal"
                  @qgResetDeal="resetGzDataDeal" style="margin-top: -2rem"></query-gather>
    <div class="commonDiv">
      <el-table
          :data="gzTableData"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          border
          size="mini"
          ref="gzTableRef"
          max-height="calc(100% - 60px)"
          style="width: 100%;"
          height="calc(100% - 60px)"
          @selection-change="tableSelectionChange"
          @sort-change="gzSortChange"
          :row-style="tableRowClassName"
          :header-cell-style="{backgroundColor:'#f9f9ff',fontSize: '1.4rem',textAlign:'center',color:'#323232',
                          fontFamily:'PingFang SC',fontWeight:'normal',fontStretch:'normal',height:'6.5vh'}">
        <template v-for="(item,index) in gzTitles">
          <template v-if="index ===0">
            <el-table-column
                :prop="item.prop"
                :width="item.width"
                :label="item.label"
                :align="item.align"
                :sortable="item.sortable"
                show-overflow-tooltip>
              <template slot-scope="scope">
                <a style="color: #46adf5;cursor: pointer;"
                   @click="gzClickDeal(scope.row)">{{ scope.row.lbbhName }}</a>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column
                :prop="item.prop"
                :width="item.width"
                :label="item.label"
                :align="item.align"
                :sortable="item.sortable"
                show-overflow-tooltip
            ></el-table-column>
          </template>
        </template>
        <el-table-column label="操作" align="center" width="150" v-if="authorityMap.isDel">
          <template slot-scope="scope">
            <!--            <span @click="setGzItemDeal(scope.row,'修改规则')" v-if="authorityMap.isUpdate">-->
            <!--              <el-tooltip content="修改" effect="light">-->
            <!--                <img-->
            <!--                    src="~@/assets/images/operates/edit.png"-->
            <!--                    alt=""-->
            <!--                    style="cursor: pointer;width: 3.5vh;height: 3.5vh;"-->
            <!--                />-->
            <!--              </el-tooltip>-->
            <!--            </span>-->
            <!--            <span @click="setGzItemDeal(scope.row,'查看规则')" v-if="authorityMap.isView">-->
            <!--              <el-tooltip content="查看" effect="light">-->
            <!--                <img-->
            <!--                    src="~@/assets/images/operates/see.png"-->
            <!--                    alt=""-->
            <!--                     style="cursor: pointer;width: 3.5vh;height: 3.5vh;"-->
            <!--                />-->
            <!--              </el-tooltip>-->
            <!--            </span>-->
            <el-tooltip content="删除" effect="light" v-if="authorityMap.isDel">
              <el-popconfirm
                  title="确定删除吗？"
                  @confirm="gzItemDeleteDeal(scope.row)"
              >
                <img
                    src="~@/assets/images/operates/delete.png"
                    alt=""
                    slot="reference"
                    style="cursor: pointer;width: 3.5vh;height: 3.5vh;"
                />
              </el-popconfirm>
            </el-tooltip>
          </template>
        </el-table-column>

      </el-table>
      <div class="commonPage2">
        <el-pagination
            @size-change="czHandleSizeChange"
            @current-change="czHandleCurrentChange"
            :page-sizes="[10, 20, 30]"
            :page-size="gzParams.size"
            :current-page="gzParams.current"
            layout="total, prev, pager, next,sizes, jumper"
            background
            :total="gzParams.total"
        >
        </el-pagination>
      </div>
    </div>
    <data-dialog :dialog-title="gzDialog.title" :is-visible="gzDialog.gzFormVisible" :is-read="isRead"
                 @dgVerifyDeal="dgVerifyDeal('gzDialog','dialog')" ref="gzDialog" @dgConfirmDeal="dgGzConfirmDeal"
                 @dgCancelDeal="dgCancelDeal">
      <div slot="dialogFrom">
        <el-form ref="dialog" :model="gzDialog.data" :rules="gzRules" label-width="100px" :disabled="isRead"
                 label-position="top" class="commonForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="规则类别" prop="lbbh" style="width: 70%;">
                <el-select
                    v-model="gzDialog.data['lbbh']"
                    size="large"
                    @change="gzSelectDeal"
                    class="dm-select"
                    placeholder="请选择规则类别"
                    style="width: 100%"
                    :disabled='isEdit'
                >
                  <el-option
                      v-for="item in gzMcOptions"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="序号" prop="xh" style="width: 70%;">
                <el-input v-model="gzDialog.data['xh']" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-show="isVisible && !isRead ">
            <el-col :span="24">
              <el-form-item label="插入测站" prop="czList" style="width: 90%;">
                <div class="gzTag" v-show="czList.length>0">
                  <template v-for="(item,index) in czList">
                    <el-tag type="success" style="margin-left: 1rem;" @click="addTagDeal(item)">
                      {{ item['stnm'] }}
                    </el-tag>
                  </template>
                </div>
                <div class="gzTag2" v-show="czList.length===0">暂无数据</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="表达式" prop="expressName" style="width: 90%;">
                <el-input v-model="gzDialog.data['expressName']" type="textarea"></el-input>
                <span style="color: #9d9d9d;font-size: 1.1rem;" v-if="isVisible">表达式仅能从上面选择并保证符合正确的运算规则</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </data-dialog>
  </el-main>
</template>

<script>
import QueryGather from "../../components/buttonGather/queryGather";
import DataDialog from "../../components/tableGather/dataDialog";

/**
 * @Author: ygh
 * @Date: 2024/3/11 10:39
 * @Description:人员信息页面
 */
export default {
  name: "rules",
  components: {QueryGather, DataDialog},
  created() {
    let windowHeight =
        document.documentElement.clientHeight || document.bodyclientHeight;
    this.stRemHeight = windowHeight / 100;
  },
  mounted() {
    this.initRulesData();
  },
  data() {
    let validateXhNum = (rule, value, callback) => {
      if (value == null || value.length == 0) {
        callback();
      } else {
        const reg = /^[0-9][0-9]*$/;
        if (reg.test(value)) {
          value = value + '';
          if (value.length > 9) {
            return callback(new Error("序号长度不超过9个字符"));
          }
          callback();
        } else {
          return callback(new Error("序号只能填0-9的数字"));
        }
      }
    };
    return {
      authorityMap: {
        isAdd: false,//新增权限
        isUpdate: false,//修改权限
        isDel: false,//删除权限
        isView: false,//查看权限
      },
      curSelectLabel: '请选择规则类别',
      ylSttps: ['0801', '0802', '0803'],
      stRemHeight: 0,
      qArr: [
        {id: 1, label: '1'},
        {id: 2, label: '1'},
        {id: 3, label: '1'},
      ],
      isEdit: false,
      isRead: false,
      isVisible: false,
      isAddData: false,
      curInputTip: '请输入规则类别',
      rulesDataArr: [],
      czList: [],
      czMcMap: null,
      gzTitles: [
        {prop: 'lbbhName', label: '规则类别', width: 180, align: 'left'},
        {prop: 'expressName', label: '计算表达式', width: null, align: 'left'},
        {prop: 'xh', label: '序号', width: 80, align: 'center', sortable: 'custom',},
      ],
      gzTableData: [],
      gzRules: {
        lbbh: [
          {required: true, message: "请选择规则", trigger: "change"},
        ],
        expressName: [
          {required: true, message: "请输入表达式", trigger: "blur"},
        ],
        xh: [
          {required: true, message: "请输入序号", trigger: "blur"},
          {validator: validateXhNum, trigger: 'blur'},
        ],
      },
      gzParams: {
        total: 0,
        size: 10,
        current: 1,
        lbbh: '',
      },
      loading: false,
      ryMultiple: true,
      ryMultipleSelection: [],
      gzMcOptions: [],
      curInputValue: '',
      gzDialog: {
        title: "",
        gzFormVisible: false,
        data: {},
      },
      czMcOptions: [],
      gzData: {
        "express": null,
        "keywords": null,
        "xh": null,
        "lbbh": '',
        "expressName": null,
        "sttp": null,
      }
    }
  },
  methods: {
    initRulesData() {
      this.pageAuthorityDeal();
      this.getRulesData();
      this.getGzOptions();
      this.getCzListByCzLb();
    },
    pageAuthorityDeal() {
      const thirdAuthority = JSON.parse(localStorage.getItem("thirdAuthority"))
      const qx = thirdAuthority[this.$route.name];
      if (qx === 'all' || qx === null) {
        this.authorityMap.isAdd = true;
        this.authorityMap.isDel = true;
        this.authorityMap.isUpdate = true;
        this.authorityMap.isView = true;
      } else {
        this.authorityMap.isAdd = qx.indexOf('新增') !== -1;
        this.authorityMap.isDel = qx.indexOf('删除') !== -1;
        this.authorityMap.isUpdate = qx.indexOf('修改') !== -1;
        this.authorityMap.isView = qx.indexOf('查询') !== -1;
      }
      // console.log("当前页面三级菜单权限", thirdAuthority, this.authorityMap);
    },
    dgCancelDeal() {
      if (this.gzDialog.gzFormVisible) {
        this.gzDialog.gzFormVisible = false;
        this.isVisible = false;
        this.isEdit = false;
        this.$refs['dialog'].clearValidate();
      }
    },
    dgGzConfirmDeal() {
      if (this.isVisible) {
        this.gzKeyDeal();
      } else {
        this.gzDialog.data.express = this.gzDialog.data.expressName;
      }
      // console.log("======dgGzConfirmDeal======", this.gzDialog.data);
      if (this.isAddData) {
        this.addRules();
      } else {
        this.updateRules();
      }
    },
    dgVerifyDeal(dgRef, frRef) {
      // console.log("======dgVerifyDeal==d====");
      this.$refs[frRef].validate((valid) => {
        if (valid) {
          this.$refs[dgRef].isShowPop(true);
        } else {
          this.$refs[dgRef].isShowPop(false);
        }
      });
    },
    addTagDeal(tagItem) {
      if (this.gzDialog.data.expressName != null) {
        this.gzDialog.data['expressName'] += '{' + tagItem['stnm'] + '}';
        this.gzDialog.data['keywords'] += tagItem['stcd'] + ',';
      } else {
        this.gzDialog.data['expressName'] = '{' + tagItem['stnm'] + '}';
        this.gzDialog.data['keywords'] = tagItem['stcd'] + ',';
      }
      // console.log("======addTagDeal======", tagItem, this.gzDialog.data);
    },
    getGzOptions() {
      this.request.get('rm-sdictionary/v1/query/09').then(res => {
        if (res.ok) {
          if (res.data != null) {
            // console.log(res, '===getGzOptions===');
            this.gzMcOptions = [];
            for (let i = 0; i < res.data.length; i++) {
              this.gzMcOptions.push({
                code: res.data[i]['code'],
                name: res.data[i]['name'],
              });
            }
          } else {
            this.$message.info("获取测站选择数据为空");
          }
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    dialogConfirmDeal() {
      this.$refs['dialog'].validate((valid) => {
        if (valid) {
          this.$refs.popFirm.visible = false;
        } else {
          this.$refs.popFirm.visible = true;
        }
      });
    },
    addRules() {
      // console.log("======addRules======", this.gzDialog.data, this.czMcOptions);
      this.request.post('/rm-brule/v1', this.gzDialog.data).then(res => {
        if (res.ok) {
          this.gzDialog.gzFormVisible = false;
          this.gzDialog.data = {};
          this.isAddData = false;
          this.getRulesData();
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    gzKeyDeal() {
      //处理关键字
      let nameArr = this.getExpressNameArr(this.gzDialog.data['expressName']);
      let key = '';
      let express = this.gzDialog.data['expressName'] + '';
      for (let i = 0; i < nameArr.length; i++) {
        if (i !== nameArr.length - 1) {
          key += this.czMcMap.get(nameArr[i]) + ',';
        } else {
          key += this.czMcMap.get(nameArr[i]);
        }
        express = express.replaceAll(nameArr[i], this.czMcMap.get(nameArr[i]));
      }
      this.gzDialog.data['express'] = express;
      this.gzDialog.data['keywords'] = key;
      // console.log("======gzKeyDeal======", this.gzDialog.data, nameArr, this.czMcMap);
    },
    getExpressNameArr(expressName) {//提取名称数组
      const regex = /\{(.*?)\}/g;
      const matches = expressName.matchAll(regex);
      const textArray = [];
      for (const match of matches) {
        textArray.push(match[1]);
      }
      return textArray;
    },
    updateRules() {
      this.request.put('/rm-brule/v1', this.gzDialog.data).then(res => {
        if (res.ok) {
          this.gzDialog.gzFormVisible = false;
          this.gzDialog.data = {};
          this.isAddData = false;
          this.getRulesData();
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    gzSelectDeal(v) {
      if (v === '0902') {//是否显示插入的测站控制
        this.isVisible = false;//不显示
      } else {
        this.isVisible = true;
      }
      // console.log("======gzSelectDeal======", v);
    },
    czSelectDeal(v) {
      // console.log("======czSelectDeal======", v);
      this.getCzListByCzLb();
    },
    getCzListByCzLb() {
      this.request.post('/rm-bstbprp/v1/listBySttp', this.ylSttps).then(res => {
        if (res.ok) {
          if (res.data != null) {
            this.czList = [];
            this.czList = res.data;
            let mcMap = new Map();
            for (let i = 0; i < this.czList.length; i++) {
              mcMap.set(this.czList[i]['stnm'], this.czList[i]['stcd']);
            }
            this.czMcMap = null;
            this.czMcMap = mcMap;
            // console.log(res, '===getCzListByCzLbRes===');
          } else {
            this.$message.info("获取数据为空");
          }
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    dialogCancelDeal() {
      this.gzDialog.gzFormVisible = false;
      this.$refs.dialog.clearValidate();
    },
    queryCzDataDeal() {
      // this.getRulesData();
    },
    resetGzDataDeal() {
      this.gzParams = {
        total: 0,
        size: 10,
        current: 1,
        lbbh: '',
      };
      this.$refs.gzTableRef.clearSort();
      this.getRulesData();
    },
    addItemDeal() {
      this.gzDialog.title = '新增规则';
      this.isRead = false;
      this.isAddData = true;
      this.isEdit = false;
      this.gzDialog.data = null;
      this.gzDialog.data = {...this.gzData};
      this.isVisible=false;
      this.$nextTick(() => {
        this.gzDialog.gzFormVisible = true;
        this.$refs.dialog.clearValidate();
      })
    },
    tableDelDeal() {
      if (this.ryMultipleSelection.length === 0) {
        this.$refs.tableDelRef.visible = true;
        this.$message.error('至少选择一项进行删除');
      }
    },
    handleAllDelete() {
      if (this.ryMultipleSelection.length === 0) {
        this.$message.error('至少选择一项进行删除');
      } else {
        let selection = [];
        for (let s of this.ryMultipleSelection) {
          selection.push(s.id);
        }
        this.delAllRules(selection);
      }
    },
    qgDownSelectDeal(params) {
      // console.log("======qgDownSelectDeal======", params);
      this.gzParams = {
        total: 0,
        size: 10,
        current: 1,
        lbbh: params.curSelectValue,
      };
      this.getRulesData();
    },
    setGzItemDeal(czData) {
      this.gzDialog.title = '规则信息';
      this.gzDialog.data = {...czData};
      this.isRead = this.authorityMap.isView && !this.authorityMap.isUpdate;
      this.isAddData = false;
      this.isVisible = czData.lbbh !== '0902';
      this.isEdit = true;
      this.gzDialog.gzFormVisible = true;
      // console.log("======setGzItemDeal======", czData);
    },
    gzItemDeleteDeal(row) {
      // console.log("======gzItemDeleteDeal======",row);
      this.request.delete('/rm-brule/v1/' + row['id']).then(res => {
        if (res.ok) {
          this.$message.success("数据删除成功");
          this.gzDialog = {
            total: 0,
            size: 10,
            current: 1,
          };
          this.getRulesData();
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    delAllRules(ids) {
      this.request.delete('/rm-brule/v1/ids', {data: ids}).then(res => {
        if (res.ok) {
          this.$message.success("数据删除成功");
          this.gzParams = {
            total: 0,
            size: 10,
            current: 1,
          };
          this.getRulesData();
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    gzSortChange(column) {
      let params = {
        total: 0,
        size: 10,
        current: 1,
        sortCol: column.prop.toUpperCase(),
        order: column.order === "descending" ? 1 : 0,
      };
      this.params = {};
      this.params = params;
      this.getRulesData();
    },
    tableSelectionChange(val) {
      this.ryMultiple = !val.length;
      this.ryMultipleSelection = val;
    },
    gzClickDeal(row) {
      if (this.authorityMap.isView || this.authorityMap.isUpdate) {
        this.setGzItemDeal(row);
      }
    },
    tableRowClassName({row, rowIndex}) {
      return {
        backgroundColor: '#ffffff',
        fontSize: '1.2rem',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontFamily: 'PingFang SC',
        color: '#616f7b',
        height: '5.83vh',
      };
    },
    czHandleSizeChange(val) {
      this.params.size = val;
      this.params.current = 1;
      this.getRulesData();
    },
    //切换页码
    czHandleCurrentChange(val) {
      this.params.current = val;
      this.getRulesData();
    },
    getRulesData() {
      this.loading = true;
      let params = {
        ...this.gzParams,
      }
      this.request.get('/rm-brule/v1/page', {params: params}).then(res => {
        if (res.ok) {
          if (res.data != null) {
            // console.log(res, '===getRulesDataRes===');
            this.gzTableData = [];
            for (let i = 0; i < res.data['records'].length; i++) {
              if (res.data['records'][i]['lbbh'] === '0902') {
                res.data['records'][i]['expressName'] = res.data['records'][i]['express'];
              }
            }
            this.gzTableData = res.data['records'];
            this.gzParams.total = res.data.total;
            this.gzParams.size = res.data.size;
          } else {
            this.$message.info("获取规则信息数据为空");
          }
        } else {
          this.$message.error(res.error.message);
        }
        this.loading = false;
      });
    },
  },
  watch: {
    "$store.state.head.skCd"() {
      this.resetGzDataDeal();
    }
  }

}
</script>

<style scoped>
/deep/ .el-pagination{
  white-space: nowrap;
  color: #303133;
  font-weight: 700;
  transform: translate(0, -50%);
  position: relative;
  top: 50%;
  right: 20px;
}
.commonPage2 {
  position: absolute;
  right: 1.5rem;
  height: 60px;
}

.commonForm {
  padding-top: 4vh;
  padding-left: 6vh;
}

.commonPage {
  position: absolute;
  right: 1.5rem;
  height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.commonDiv {
  position: relative;
  background-color: #FFFFFF;
  height: calc(100vh - 200px);
}

.gzTag {
  border: 1px solid #C0C4CC;
  padding: 0.5rem;
  border-radius: 0.5rem;
}

.gzTag2 {
  border: 1px solid #C0C4CC;
  padding: 0.5rem;
  border-radius: 0.5rem;
  height: 4rem;
  text-align: center;
  color: #9d9d9d;
  font-size: 1.4rem;
}

</style>
